import * as THREE from 'three';

const LOGO_DEFINITIONS = [
    {
        name: 'Instagram',
        fillBg: '#E1306C',
        bgGradient: ['#833ab4', '#fd1d1d', '#fcb045'],
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="160" height="160" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
            <circle cx="17.5" cy="6.5" r="1.5" fill="white"/>
        </svg>`
    },
    {
        name: 'YouTube',
        fillBg: '#FF0000',
        bgGradient: ['#E60000', '#FF2626'],
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="180" height="180" fill="white">
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>`
    },
    {
        name: 'WhatsApp',
        fillBg: '#25D366',
        bgGradient: ['#1EBE57', '#25D366'],
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="170" height="170" fill="white">
            <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91 0-5.46-4.45-9.91-9.91-9.91zm5.44 14.21c-.27.76-1.59 1.36-2.21 1.45-.53.07-1.12.14-3.23-.74-2.55-1.07-4.21-3.69-4.34-3.86-.13-.17-1.04-1.38-1.04-2.63 0-1.25.65-1.87.89-2.12.23-.25.54-.31.72-.31.18 0 .36 0 .52.01.17.01.39-.06.61.47.23.55.76 1.84.83 1.98.07.14.11.3.02.48-.09.18-.14.3-.27.46-.14.15-.29.33-.4.45-.14.14-.28.29-.12.56.16.27.71 1.17 1.54 1.9.1.09 1.14.88 1.91 1.21.27.11.55.15.76.02.32-.2.72-.84.91-1.12.18-.29.36-.24.61-.15.25.09 1.58.74 1.85.88.27.14.45.21.52.33.07.12.07.71-.2 1.47z"/>
        </svg>`
    },
    {
        name: 'Facebook',
        fillBg: '#1877F2',
        bgGradient: ['#0A60D4', '#1877F2'],
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="170" height="170" fill="white">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>`
    },
    {
        name: 'Meta',
        fillBg: '#0081FB',
        bgGradient: ['#0064E0', '#0081FB'],
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="180" height="180" fill="white">
            <path d="M22.5 12c0-3.58-2.28-6-5.5-6-2.09 0-3.87 1.05-4.99 2.66C10.89 7.05 9.11 6 7 6 3.78 6 1.5 8.42 1.5 12c0 3.58 2.28 6 5.5 6 2.11 0 3.89-1.05 5.01-2.66 1.12 1.61 2.9 2.66 5.01 2.66 3.22 0 5.48-2.42 5.48-6zm-15.5 4c-2.12 0-3.5-1.63-3.5-4s1.38-4 3.5-4c1.55 0 2.87.89 3.55 2.19C9.9 11.39 9.3 13.06 8.5 14.5c-.41.74-.91 1.5-1.5 1.5zm11 0c-.59 0-1.09-.76-1.5-1.5-.8-1.44-1.4-3.11-2.05-4.31C15.13 8.89 16.45 8 18 8c2.12 0 3.5 1.63 3.5 4s-1.38 4-3.5 4z"/>
        </svg>`
    },
    {
        name: 'Snapchat',
        fillBg: '#FFFC00',
        bgGradient: ['#E6E300', '#FFFC00'],
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="160" height="160" fill="white" stroke="black" stroke-width="1.2">
            <path d="M12.007 2c-3.792 0-6.19 2.656-6.19 5.86 0 1.176.326 2.45.88 3.391-.49.19-.948.406-1.353.648-.487.292-.797.74-.683 1.254.103.46.544.757 1.057.887.652.164 1.343.14 1.942.062.247 1.036.852 1.97 1.83 2.502-.314.168-.66.302-1.037.382-1.083.227-1.448.74-1.428 1.176.028.608.85 1.054 2.176 1.189 1.196.12 2.274-.29 2.806-.525.532.235 1.61.645 2.806.525 1.326-.135 2.148-.581 2.176-1.189.02-.436-.345-.949-1.428-1.176-.377-.08-.723-.214-1.037-.382.978-.532 1.583-1.466 1.83-2.502.599.078 1.29.102 1.942-.062.513-.13.954-.427 1.057-.887.114-.514-.196-.962-.683-1.254-.405-.242-.863-.458-1.353-.648.554-.941.88-2.215.88-3.391 0-3.204-2.398-5.86-6.19-5.86z"/>
        </svg>`
    },
    {
        name: 'LinkedIn',
        fillBg: '#0A66C2',
        bgGradient: ['#004182', '#0A66C2'],
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="170" height="170" fill="white">
            <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.28 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.75M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
        </svg>`
    }
];

function createLogoTextures() {
    return LOGO_DEFINITIONS.map(def => {
        const canvas = document.createElement('canvas');
        canvas.width = 512;
        canvas.height = 512;
        const ctx = canvas.getContext('2d');

        let grad;
        if (def.bgGradient && def.bgGradient.length === 3) {
            grad = ctx.createLinearGradient(0, 0, 512, 512);
            grad.addColorStop(0, def.bgGradient[0]);
            grad.addColorStop(0.5, def.bgGradient[1]);
            grad.addColorStop(1, def.bgGradient[2]);
        } else if (def.bgGradient) {
            grad = ctx.createLinearGradient(0, 0, 512, 512);
            grad.addColorStop(0, def.bgGradient[0]);
            grad.addColorStop(1, def.bgGradient[1]);
        } else {
            grad = def.fillBg;
        }
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, 512, 512);

        // Glossy radial highlight
        const shine = ctx.createRadialGradient(256, 128, 20, 256, 256, 360);
        shine.addColorStop(0, 'rgba(255, 255, 255, 0.35)');
        shine.addColorStop(1, 'rgba(0, 0, 0, 0.25)');
        ctx.fillStyle = shine;
        ctx.fillRect(0, 0, 512, 512);

        const texture = new THREE.CanvasTexture(canvas);
        texture.colorSpace = THREE.SRGBColorSpace;

        const img = new Image();
        const svgBlob = new Blob([def.svg], { type: 'image/svg+xml;charset=utf-8' });
        const url = URL.createObjectURL(svgBlob);

        img.onload = () => {
            const iconSize = 160;
            const offset = (512 - iconSize) / 2;
            // Clip to circle so icon stays within sphere face
            ctx.save();
            ctx.beginPath();
            ctx.arc(256, 256, 180, 0, Math.PI * 2);
            ctx.clip();
            ctx.drawImage(img, offset, offset, iconSize, iconSize);
            ctx.restore();
            texture.needsUpdate = true;
            URL.revokeObjectURL(url);
        };
        img.src = url;

        return texture;
    });
}

// -------------------------------------------------------------
// EXACT THREEJS-COMPONENTS SPHERES1 PHYSICS ENGINE
// -------------------------------------------------------------
const { randFloat: k, randFloatSpread: E } = THREE.MathUtils;
const F = new THREE.Vector3();
const I = new THREE.Vector3();
const O = new THREE.Vector3();
const V = new THREE.Vector3();
const B = new THREE.Vector3();
const N = new THREE.Vector3();
const _ = new THREE.Vector3();
const j = new THREE.Vector3();
const H = new THREE.Vector3();
const T = new THREE.Vector3();

class Spheres1Physics {
    constructor(config) {
        this.config = config;
        this.positionData = new Float32Array(3 * config.count).fill(0);
        this.velocityData = new Float32Array(3 * config.count).fill(0);
        this.sizeData = new Float32Array(config.count).fill(1);
        this.center = new THREE.Vector3();
        this.resetPositions();
        this.setSizes();
    }

    resetPositions() {
        const { config, positionData } = this;
        this.center.toArray(positionData, 0);
        for (let i = 1; i < config.count; i++) {
            const s = 3 * i;
            positionData[s] = E(2 * config.maxX);
            positionData[s + 1] = config.maxY + k(2, 20); // spawn above viewport
            positionData[s + 2] = E(2 * config.maxZ);
        }
    }

    setSizes() {
        const { config, sizeData } = this;
        sizeData[0] = config.size0;
        for (let i = 1; i < config.count; i++) {
            sizeData[i] = k(config.minSize, config.maxSize);
        }
    }

    update(dt) {
        const { config, center, positionData, sizeData, velocityData } = this;
        let startIndex = 0;

        if (config.controlSphere0) {
            startIndex = 1;
            F.fromArray(positionData, 0);
            F.lerp(center, 0.15).toArray(positionData, 0); // Lerp mouse sphere 0
            V.set(0, 0, 0).toArray(velocityData, 0);
        }

        // Apply Gravity, Velocity, Friction
        for (let i = startIndex; i < config.count; i++) {
            const r = 3 * i;
            I.fromArray(positionData, r);
            B.fromArray(velocityData, r);

            B.y -= dt.delta * config.gravity * sizeData[i] * 12; // Gravity downwards
            B.multiplyScalar(config.friction);
            B.clampLength(0, config.maxVelocity);

            I.add(B);
            I.toArray(positionData, r);
            B.toArray(velocityData, r);
        }

        // Sphere-Sphere Collisions
        for (let e = startIndex; e < config.count; e++) {
            const i = 3 * e;
            I.fromArray(positionData, i);
            B.fromArray(velocityData, i);
            const r = sizeData[e];

            for (let a = e + 1; a < config.count; a++) {
                const eIdx = 3 * a;
                O.fromArray(positionData, eIdx);
                N.fromArray(velocityData, eIdx);
                const t = sizeData[a];

                _.copy(O).sub(I);
                const c = _.length();
                const h = r + t;

                if (c < h && c > 0.0001) {
                    const overlap = h - c;
                    j.copy(_).normalize().multiplyScalar(0.5 * overlap);
                    H.copy(j).multiplyScalar(Math.max(B.length(), 1));
                    T.copy(j).multiplyScalar(Math.max(N.length(), 1));

                    I.sub(j);
                    B.sub(H);
                    I.toArray(positionData, i);
                    B.toArray(velocityData, i);

                    O.add(j);
                    N.add(T);
                    O.toArray(positionData, eIdx);
                    N.toArray(velocityData, eIdx);
                }
            }

            // Collide with Mouse Sphere 0 if active
            if (config.controlSphere0) {
                _.copy(F).sub(I);
                const dist = _.length();
                const minDist = r + sizeData[0];
                if (dist < minDist && dist > 0.0001) {
                    const overlap = minDist - dist;
                    j.copy(_).normalize().multiplyScalar(overlap);
                    H.copy(j).multiplyScalar(Math.max(B.length(), 2));
                    I.sub(j);
                    B.sub(H);
                }
            }

            // Wall Collisions
            if (Math.abs(I.x) + r > config.maxX) {
                I.x = Math.sign(I.x) * (config.maxX - r);
                B.x = -B.x * config.wallBounce;
            }

            if (config.gravity === 0) {
                if (Math.abs(I.y) + r > config.maxY) {
                    I.y = Math.sign(I.y) * (config.maxY - r);
                    B.y = -B.y * config.wallBounce;
                }
            } else {
                if (I.y - r < -config.maxY) {
                    I.y = -config.maxY + r;
                    B.y = -B.y * config.wallBounce;
                }
            }

            const maxZBound = Math.max(config.maxZ, config.maxSize);
            if (Math.abs(I.z) + r > maxZBound) {
                I.z = Math.sign(I.z) * (config.maxZ - r);
                B.z = -B.z * config.wallBounce;
            }

            I.toArray(positionData, i);
            B.toArray(velocityData, i);
        }
    }
}

const isMobile = window.innerWidth <= 768;

const DEFAULT_CONFIG = {
    count: isMobile ? 10 : 40,
    minSize: isMobile ? 0.3 : 0.7,
    maxSize: isMobile ? 0.7 : 1.4,
    size0: isMobile ? 0.9 : 1.8,
    gravity: 0.5,
    friction: 0.9975,
    wallBounce: 0.95,
    maxVelocity: 0.2,
    maxX: 8,
    maxY: 5,
    maxZ: 2,
    controlSphere0: false
};

export default function FooterSpheres(canvas, userOptions = {}) {
    if (!canvas) return;

    const config = { ...DEFAULT_CONFIG, ...userOptions };

    const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(50, 1, 0.1, 100);
    camera.position.set(0, 0, 20);
    camera.lookAt(0, 0, 0);

    // Lighting
    const ambientLight = new THREE.AmbientLight(0xffffff, 1.4);
    scene.add(ambientLight);

    const dirLight1 = new THREE.DirectionalLight(0xffffff, 2.5);
    dirLight1.position.set(12, 18, 15);
    scene.add(dirLight1);

    const dirLight2 = new THREE.DirectionalLight(0xffffff, 1.0);
    dirLight2.position.set(-12, -10, -10);
    scene.add(dirLight2);

    const textures = createLogoTextures();
    const geometry = new THREE.SphereGeometry(1, 32, 32);

    const physics = new Spheres1Physics(config);

    // Create Mesh for each sphere with social logo texture
    const dummy = new THREE.Object3D();
    const meshes = Array.from({ length: config.count }, (_, i) => {
        const tex = textures[i % textures.length];
        const mat = new THREE.MeshStandardMaterial({
            map: tex,
            roughness: 0.2,
            metalness: 0.1
        });
        const mesh = new THREE.Mesh(geometry, mat);
        scene.add(mesh);
        return mesh;
    });

    function updateWorldSize() {
        const parent = canvas.parentElement || document.body;
        const w = parent.offsetWidth || window.innerWidth;
        const h = parent.offsetHeight || window.innerHeight || 400;
        renderer.setSize(w, h);
        camera.aspect = w / h;
        camera.updateProjectionMatrix();

        const vFov = (camera.fov * Math.PI) / 180;
        const visH = 2 * Math.tan(vFov / 2) * camera.position.length();
        const visW = visH * camera.aspect;

        config.maxX = visW / 2;
        config.maxY = visH / 2;
    }
    updateWorldSize();
    window.addEventListener('resize', updateWorldSize);

    // -------------------------------------------------------------
    // EXACT MOUSE RAYCASTER & POINTER TRACKING FROM SPHERES1
    // -------------------------------------------------------------
    const raycaster = new THREE.Raycaster();
    const plane = new THREE.Plane(new THREE.Vector3(0, 0, 1), 0);
    const mouseIntersection = new THREE.Vector3();
    const pointer = new THREE.Vector2();

    function onPointerMove(e) {
        const rect = canvas.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        if (x >= 0 && x <= rect.width && y >= 0 && y <= rect.height) {
            pointer.x = (x / rect.width) * 2 - 1;
            pointer.y = -(y / rect.height) * 2 + 1;

            raycaster.setFromCamera(pointer, camera);
            camera.getWorldDirection(plane.normal);
            raycaster.ray.intersectPlane(plane, mouseIntersection);

            physics.center.copy(mouseIntersection);
            config.controlSphere0 = true;
        } else {
            config.controlSphere0 = false;
        }
    }

    function onPointerLeave() {
        config.controlSphere0 = false;
    }

    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerleave', onPointerLeave);

    // Animation Loop
    let animationFrameId;
    let clock = new THREE.Clock();

    function animate() {
        animationFrameId = requestAnimationFrame(animate);

        const delta = clock.getDelta();
        physics.update({ delta: Math.min(delta, 0.033) });

        // Synchronize Three.js Meshes with Physics Engine
        for (let i = 0; i < config.count; i++) {
            const mesh = meshes[i];
            const px = physics.positionData[3 * i];
            const py = physics.positionData[3 * i + 1];
            const pz = physics.positionData[3 * i + 2];
            const size = physics.sizeData[i];

            mesh.position.set(px, py, pz);
            mesh.scale.setScalar(size);

            // Face camera so icon is always visible
            mesh.quaternion.copy(camera.quaternion);
        }

        renderer.render(scene, camera);
    }

    animate();

    const instance = {
        spheres: {
            config,
            physics,
            setGravity(val) {
                config.gravity = val;
            },
            toggleGravity() {
                config.gravity = config.gravity === 0 ? 0.5 : 0;
                return config.gravity;
            }
        },
        destroy() {
            cancelAnimationFrame(animationFrameId);
            window.removeEventListener('resize', updateWorldSize);
            window.removeEventListener('pointermove', onPointerMove);
            window.removeEventListener('pointerleave', onPointerLeave);
            renderer.dispose();
        }
    };

    return instance;
}
